import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3a4f90fc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=3a4f90fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f90fc",
  null
  
)

export default component.exports